import { REQUIREMENT_INTAKE_MODE_KEY } from '../../application/composer/mode-contract.js';

const firstTruthy = (...readers) => readers.reduce((result, read) => result || read(), undefined);

function resolveObject(value = null) {
  return value && typeof value === 'object' && !Array.isArray(value) ? value : null;
}

function normalizeText(value = '') {
  return String(value || '').trim();
}

export function normalizeIntakeAction(rawAction = {}, index = 0) {
  const action = firstTruthy(() => (resolveObject(rawAction)), () => ({}));
  const actionKey = normalizeText(firstTruthy(() => (action.action_key), () => (action.command), () => (action.id), () => (index + 1)));
  const payload = firstTruthy(() => (resolveObject(action.payload)), () => ({}));
  const command = firstTruthy(() => (normalizeText(payload.command || action.command || actionKey)), () => (actionKey));
  const targetMode = firstTruthy(() => (normalizeText(action.target_mode || payload.target_mode || REQUIREMENT_INTAKE_MODE_KEY)), () => (REQUIREMENT_INTAKE_MODE_KEY));
  return {
    key: actionKey,
    text: normalizeText(firstTruthy(() => (action.label), () => (action.text))),
    answerValue: normalizeText(firstTruthy(() => (action.answer_value), () => (action.label), () => (action.text))),
    action: {
      action_key: actionKey,
      target_mode: targetMode,
      payload: {
        ...payload,
        action_key: actionKey,
        command,
        action_command: firstTruthy(() => (normalizeText(payload.action_command || command)), () => (command)),
        target_mode: targetMode,
      },
    },
    source: 'intake_action',
  };
}

export function isRevisionConfirmAction(action = {}) {
  const actionKey = normalizeText(Object(action).action_key || Object(action).actionKey || Object(action).key);
  const actionType = normalizeText(Object(action).type || Object(action).action_type);
  return (
    actionType === 'confirm_revision'
    || actionKey === 'accept_canvas_revision'
    || actionKey === 'reject_canvas_revision'
  );
}

export function isGenericContinueAction(action = {}) {
  const actionKey = normalizeText(Object(Object(action).action).action_key || Object(action).action_key || Object(action).key);
  const command = normalizeText(Object(Object(Object(action).action).payload).command || Object(action).command);
  return actionKey === 'continue_collection' || command === 'continue_collection';
}
